import Api from 'App/api'

export const getGuestListWithSettings = Api.get({
  controller: 'guest_list',
  action: 'listWithSettings',
})

export const saveGuest = Api.post({
  controller: 'guest_list',
  action: 'save',
})

export const deleteGuest = Api.post({
  controller: 'guest_list',
  action: 'delete',
})
